/**
 * Class to create a user model object that reflects a single user from our database.
 * @param authentificationtoken string token that identifies and authenticates the user in the database.
 * @param localization string localization of the user to be used for setting the locale in our app.
 * @param email string user email adress.
 * @param password string user password.
 * @param firstName string first name of the user.
 * @param lastName string last name of the user.
 * @param company string company where the user is employed.
 * @param id string numerical identification to distinguish the users in the database.
 * @param profileImageId string numerical identifier of the image in the database.
 * @param profileImageDataId string hexadecimal representation of the image to retrieve its data from the database. #
 * @param versionMajor string major version of the app.
 * @param versionMinor string minor version of the app.
 * @param country string country of the user.
 *
 * @class UserModel object that can be cached later.
 */

 export interface IUser {
  authentificationtoken: string;
  localization: string;
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  id: string;
  profileImageId: string;
  profileImageDataId: string;
  versionMajor: string;
  versionMinor: string;
  country: string;
}

class UserModel implements IUser {
  authentificationtoken: string;

  localization: string;

  email: string;

  firstName: string;

  lastName: string;

  company: string;

  id: string;

  profileImageId: string;

  profileImageDataId: string;

  versionMajor: string;

  versionMinor: string;

  country: string;

  constructor(
    authentificationtoken: string,
    localization: string,
    email: string,
    firstName: string,
    lastName: string,
    company: string,
    id: string,
    profileImageId: string,
    profileImageDataId: string,
    versionMajor: string,
    versionMinor: string,
    country: string
  ) {
    this.authentificationtoken = authentificationtoken;
    this.localization = localization;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.company = company;
    this.id = id;
    this.profileImageId = profileImageId;
    this.profileImageDataId = profileImageDataId;
    this.versionMajor = versionMajor;
    this.versionMinor = versionMinor;
    this.country = country;
  }
}

export default UserModel;